module.exports = "/_next/static/images/rocketship-24fd7f849928772d7958b1e23a20efd0.png";